import { bustCacheArg } from '../constants';

export default function bustImageCache(url) {
	if (url.indexOf('?') >= 0) {
		url += '&' + bustCacheArg;
	} else {
		url += '?' + bustCacheArg;
	}
	return url;
}
